import
  React
from 'react';

import
  styled
from 'styled-components';

import ReactGA from 'react-ga4';

import {
  Environment,
  Logger,
  Theme
} from 'common';

import {
  Header,
  Loader,
  ShareMeta,
  Text,
  Toast,
} from 'common/components';

import {
  useWidget,
} from 'common/contexts';

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  display: ${props => props.show ? 'flex' : 'none'};
  flex-direction: column;
  align-items: center;
  background-color: ${props => props.backgroundColor};
  flex: 1;
`;

const LoaderContainer = styled(Content)`
  display: ${props => props.show ? 'flex' : 'none'};
  background-color: ${Theme.Content.Background};
  justify-content: center;
  align-items: center;
  padding: 0 0 5vh 0;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 5;
`;

const ContentContent = styled.div`
  position: relative;
  width: 100%;
  ${props => props.applyMaxWidth && 'max-width: 1600px'};
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const FooterBanner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${Theme.Footer.Background || '#1a1a1a'};
  color: ${Theme.Footer.Text || 'white'};
  padding: 8px 0;
  font-size: 12px;
  width: 100%;
`;

export const withCommon = (WrappedComponent, options = {}) => {

  const {
    applyMaxWidth = true,
    showHeader = true,
    showProfileMenu = false,
    transparentHeader = false,
    transitionHeader = false,
    showHeaderYourTickets = false,
    showLoadingOnLoad = true,
    contentBackgroundColor = 'var(--main-content-background-color)',
    addDefaultMetaTags = true,
    scrollToTop = true,
  } = options;

  return props => {

    const [showLoader, setShowLoader] = React.useState({
      show: showLoadingOnLoad,
      message: ''
    });

    const [toast, setToast] = React.useState({
      show: false,
      message: '',
      type: 'error'
    });

    const isWidget = useWidget();

    const navigate = (path, options = {}) => {

      if (!path || !props.history) {
        return;
      }

      if (path === -1) {
        props.history.goBack();
      } else if (options.replace) {
        typeof props.history.replace === 'function' && props.history.replace(path);
      } else {
        typeof props.history.push === 'function' && props.history.push(path);
      }
    };

    const showLoading = (message) => {

      setShowLoader({
        show: true,
        message: message
      });
    };

    const hideLoading = () => {

      setShowLoader({
        show: false,
        message: ''
      });
    };

    const showToast = (message, type = 'error') => {

      setToast({
        show: true,
        message: message,
        type: type
      });
    };

    const hideToast = () => {

      setToast({
        show: false,
        message: ''
      });
    };

    const common = {
      pathParams: props.match?.params || {},
      history: props.history,
      location: props.location,
      isWidget,
      navigate,
      showLoading,
      hideLoading,
      showToast,
      hideToast,
    };

    React.useEffect(() => {

      if (Environment.name === 'Production') {
        const page = props.location.pathname + props.location.search;
        ReactGA.send({ hitType: "pageview", page: props.location.pathname + props.location.search, title: page });
      }

      if (props.location?.pathname !== '/event/payment-frame') {
        // Hide any iframes with IDs starting with 'inline-background' or 'inline-checkout'
        const iframes = Array.from(document.getElementsByTagName('iframe'));
        for (const iframe of iframes) {
          if ((iframe.id.startsWith('inline-background') || iframe.id.startsWith('inline-checkout')) && iframe.style.display !== 'none') {
            iframe.style.display = 'none';
            iframe.style.visibility = 'hidden';
            Logger.info('withCommon', 'hideIframes', 'PAYMENT IFRAME REMOVED: ' + iframe.id + ' from ' + props.location.pathname);
          }
        }
      }

      if (scrollToTop) {
        window.scrollTo(0, 0);
      }
  
    }, [props.location]);

    return (

      <>
      {!isWidget && addDefaultMetaTags &&
        <ShareMeta url="https://weticket.co.za/" />
      }

      <Container>

        { showHeader && !isWidget &&

          <Header
            showHeaderYourTickets={showHeaderYourTickets}
            transitionHeader={transitionHeader}
            onLogoClick={() => navigate('/home')}
            navigate={navigate}
            showProfileMenu={showProfileMenu}
            isBackgroundTransparent={transparentHeader}
          />
        }

        <LoaderContainer show={showLoader.show}>

          <Loader/>

          { showLoader.message && 
          
            <Text zIndex={1} padding={'20px 0 0 0'}>{showLoader.message}</Text>
          }

        </LoaderContainer>
    
        <Content
          id={'main-content'}
          show={!showLoader.show}
          backgroundColor={contentBackgroundColor}>

          <ContentContent
            applyMaxWidth={applyMaxWidth}>

            <WrappedComponent
              common={common}
            />

          </ContentContent>

        </Content>

        {false && isWidget && (
          <FooterBanner>
            Powered By <a href="https://weticket.co.za" target="_blank" rel="noopener noreferrer" style={{ marginLeft: '5px', color: Theme.Footer.Link || '#3498db', textDecoration: 'none' }}>Weticket</a>
          </FooterBanner>
        )}

        <Toast
          show={toast.show}
          message={toast.message}
          type={toast.type || 'error'}
          onClose={hideToast}
        />

      </Container>

      </>
    );
  };
};